






















































import { Component, Vue } from "vue-property-decorator";
import Base from "@/template/public/Base.vue";
import { Tab, Tabs, Loading, List } from "vant";
import NewsItem from "@/components/NewsItem.vue";
import request from "@/api/wanzhou/index";
import native from "@/common/Native";
import { Base64 } from "js-base64";
import AppPrompt from "@/components/AppPrompt.vue";
import { ISpecialDetail, IInfoThemeDetails } from "@/api/wanzhou/types";
import { IShareConfig, IShareConfigItem } from "@/api/types";
import { wxChatShare } from "@/common/wechat";
import { wxChatJumpApp } from "@/common/wechatapp";
import { findNameByAppconfig } from "@/common/Utils";
import Poster from "@/components/Poster.vue";
import { getData, time } from "@/common/dataCollect";
import { findNameByWechatAppid } from "@/common/Utils";
@Component({
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    NewsItem,
    [Loading.name]: Loading,
    AppPrompt,
    vanList: List,
    Poster
  }
})
export default class SpecialPage extends Base {
  private newsList: IInfoThemeDetails[] = [];
  private specialDetail: any = {};
  public request = new request();

  private newsLoaded: boolean = false;
  private lastId: string = "";
  private infoThemeId: string = "";
  private sortNoValue: string = "";
  private onlineTimeValue: string = "";
  public appId: string = "";
  private listLoading: boolean = false;
  private finished: boolean = false;
  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  wxAppId = "";
  isRequestLoaded = false;
  created() {
    this.startTime = time();
    /** 2022-4-14 写死跳转连接 */
    const infoClassifyId = this.$route.query.id
      ? (this.$route.query.id as string)
      : (this.$route.query.cid as string) || "2435342";
    const appId = (this.$route.query.appId as string) || "";
    if (infoClassifyId === "89404115" && appId === "25") {
      window.location.href =
        "https://h5.cqliving.com/info/link_news_detail/88118026.html";
    }

    if (infoClassifyId === "5000061291" && appId === "25") {
      window.location.href =
        "https://news.cqjjnet.com/h5/column/col1915087.html";
    }

    if (infoClassifyId === "5000061309" && appId === "25") {
      window.location.href =
        "https://news.cqjjnet.com/h5/column/col1915079.html";
    }
  }

  mounted() {
    // this.infoClassifyId = (this.$route.query.cid as string) || "2435342";
    this.infoClassifyId = this.$route.query.id
      ? (this.$route.query.id as string)
      : (this.$route.query.cid as string) || "2435342";
    this.appId = (this.$route.query.appId as string) || "";
    //获取分享详情
    this.getSpecialDetail();
    this.getCount();
    this.wxAppId = findNameByWechatAppid(this.$store.state.appInfo, this.appId);
  }
  onListLoad() {
    if (this.newsList.length == 0) {
      return;
    }
    // console.log("scroll loading");
    this.getInfoThemeList();
  }
  getSpecialDetail() {
    this.request.specialDetail(this.infoClassifyId).then(result => {
      if (result.code == 0) {
        this.specialDetail = result.data;
        this.infoThemeId = Array.isArray(result.data.infoThemeList)
          ? result.data.infoThemeList[0].id + ""
          : "";
        //设置title
        document.title = this.specialDetail.title;
        this.getInfoThemeList();
        // document.title = this.specialDetail.title;
        this.getShareInfo(this.specialDetail.appId);
        this.isRequestLoaded = true;
        // 微信一键唤醒
        var appInfo = this.$store.state.appInfo;
        var appConfig = findNameByAppconfig(
          appInfo,
          this.appId || (this.$route.query.appId as string)
        );
        const wechatConfigId = appConfig.wechatConfigId;
        const linkUrl = window.location.href;
        if (
          linkUrl &&
          appConfig.realmUrl &&
          linkUrl.indexOf(appConfig.realmUrl) != -1
        ) {
          wxChatJumpApp(
            wechatConfigId,
            this.specialDetail.title,
            this.specialDetail.synopsis,
            window.location.href,
            this.specialDetail.shareImgUrl
          );
        } else {
          wxChatShare(
            this.specialDetail.title,
            this.specialDetail.synopsis,
            window.location.href,
            this.specialDetail.shareImgUrl
          );
        }
        this.$nextTick(() => {
          // 埋点
          this.endTime = time();
          if (this.dataSource) {
            getData(this.startTime, this.endTime, this.specialDetail);
            this.dataSource = false;
          }
        });
      }
    });
  }

  getInfoThemeList() {
    let lastId: string = "",
      sortNoValue: string = "",
      onlineTimeValue: string = "";
    if (this.newsList.length > 0) {
      let lastItem = this.newsList[this.newsList.length - 1];
      lastId = String(lastItem["id"]);
      sortNoValue = String(lastItem["sortNo"]);
      onlineTimeValue = String(lastItem["onlineTime"]);
    }
    this.newsLoaded = true;
    this.request
      .infoThemeList(
        this.infoClassifyId,
        this.infoThemeId,
        this.appId,
        lastId,
        sortNoValue,
        onlineTimeValue
      )
      .then(result => {
        this.newsLoaded = false;
        if (result.code == 0) {
          if (result.data.dataList.length < 10) {
            this.finished = true;
          }
          result.data.dataList.forEach(item => {
            if (item.images) {
              item.imgList = (item.images as string).split(";");
            } else {
              item.imgList = [];
            }
          });
          this.newsList = this.newsList.concat(result.data.dataList);
        }
        this.listLoading = false;
      })
      .finally(() => {
        this.listLoading = false;
      });
  }

  tabChange(index: number, name: string) {
    this.newsList = [];
    this.finished = false;
    this.listLoading = true;
    this.infoThemeId =
      (this.specialDetail as ISpecialDetail).infoThemeList[index].id + "";
    this.getInfoThemeList();
  }
  //跳转热点详情
  newItemClick(item: any) {
    if (native.isOpenInApp()) {
      native.openWebBrowser({
        id: item.id,
        sourceId: item.informationId,
        detailViewType: item.detailViewType,
        sourceType: item.sourceType,
        commentType: item.commentType,
        contextType: item.contextType,
        isShowTop: "1",
        isShowBottom: "1",
        isShowMore: "1",
        url: item.url,
        shareUrl: item.shareUrl,
        title: Base64.encode(item.title), //base 64
        synopsis: Base64.encode(item.synopsis), //base 64
        shareImgUrl: item.shareImgUrl,
        videoFormat: item.videoFormat ? item.videoFormat : ""
      });
    } else {
      // 分享出去 外链新闻增加浏览量的操作（因为无法在详情中增加浏览量）
      if (item.sourceType == 1) {
        // 外链
        this.request.getCount(this.appId, item.id);
      }
      window.location.href = item.url;
    }
  }
  getCount() {
    if (!native.isOpenInApp()) {
      // 在app外才需要增加浏览量
      this.request.getCount(this.appId, this.infoClassifyId);
    }
  }
  // getShareInfo() {
  //   this.request
  //     .getShareInfoMethod(this.appId)
  //     .then((response: IShareConfig) => {
  //       if (response.code >= 0) {
  //         this.shareInfo = response.data;
  //       }
  //     });
  // }
}
